module.exports = __webpack_public_path__ + "img/lz.72eeb9bc.jpg";